const generateForm08 = [
  {
    label: "คำนำหน้า (ภาษาอังกฤษ)", // i18n-ignore (translated at render site)
    name: "title_en",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ชื่อ (ภาษาอังกฤษ)", // i18n-ignore (translated at render site)
    name: "first_name_en",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "นามสกุล (ภาษาอังกฤษ)", // i18n-ignore (translated at render site)
    name: "last_name_en",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ฉายา (ภาษาอังกฤษ)", // i18n-ignore (translated at render site)
    name: "buddhist_name_en",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ข้อมูลการปฏิบัติงาน", // i18n-ignore (translated at render site)
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },

  {
    label: "องค์การที่กำลังปฏิบัติงาน", // i18n-ignore (translated at render site)
    name: "organization",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 8 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "ประเทศ", // i18n-ignore (translated at render site)
    name: "country",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "ตำแหน่ง", // i18n-ignore (translated at render site)
    name: "position",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 6 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "ระดับ", // i18n-ignore (translated at render site)
    name: "level",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "ตั้งแต่วันที่", // i18n-ignore (translated at render site)
    name: "since_date",
    placeholder: "",
    type: "date",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "จำนวนครั้งที่ได้รับอนุญาตให้ไปปฏิบัติงานติดต่อกัน", // i18n-ignore (translated at render site)
    name: "work_permit_amonth",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "รวมระยะเวลาติดต่อกันมาแล้ว (ปี)", // i18n-ignore (translated at render site)
    name: "total_consecutive_period_year",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "รวมระยะเวลาติดต่อกันมาแล้ว (เดือน)", // i18n-ignore (translated at render site)
    name: "total_consecutive_period_month",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },

  {
    label: "",
    name: "time_work_permit",
    placeholder: "",
    type: "input-array-period",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },

  {
    label: "สถานที่ติดต่อปัจจุบัน", // i18n-ignore (translated at render site)
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "บ้านเลขที่", // i18n-ignore (translated at render site)
    name: "house_no",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 2 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },
  {
    label: "ถนน", // i18n-ignore (translated at render site)
    name: "street",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },
  {
    label: "หมู่บ้าน/อาคาร", // i18n-ignore (translated at render site)
    name: "village",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },
  {
    label: "ประเทศ", // i18n-ignore (translated at render site)
    name: "country",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },
  {
    label: "จังหวัด/รัฐ", // i18n-ignore (translated at render site)
    name: "province",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },
  {
    label: "เขต/อำเภอ", // i18n-ignore (translated at render site)
    name: "district",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },
  {
    label: "แขวง/ตำบล", // i18n-ignore (translated at render site)
    name: "district_sub",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },
  {
    label: "รหัสไปรษณีย์", // i18n-ignore (translated at render site)
    name: "postcode",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },

  {
    label: "ข้อมูลเกี่ยวกับการปฏิบัติงานที่ขอต่อ", // i18n-ignore (translated at render site)
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "องค์การที่ขออยู่ปฏิบัติงาน", // i18n-ignore (translated at render site)
    name: "organization_requesting_work",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "info_about_religious_continued",
  },
  {
    label: "ตำแหน่ง", // i18n-ignore (translated at render site)
    name: "position",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "info_about_religious_continued",
  },
  {
    label: "ระดับ", // i18n-ignore (translated at render site)
    name: "level",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "info_about_religious_continued",
  },
  {
    label: "ตั้งแต่วันที่", // i18n-ignore (translated at render site)
    name: "start_date",
    placeholder: "",
    type: "date",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "info_about_religious_continued",
  },
  {
    label: "ถึงวันที่", // i18n-ignore (translated at render site)
    name: "end_date",
    placeholder: "",
    type: "date",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "info_about_religious_continued",
  },

  {
    label: "ข้อมูลค่าตอบแทน", // i18n-ignore (translated at render site)
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "เงินเดือน อัตราเงินเดือน/ปีละ", // i18n-ignore (translated at render site)
    name: "saraly_rate",
    placeholder: "",
    type: "checkbox-input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    radioName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "remuneration_info",
  },
  {
    label: "ค่าที่พัก", // i18n-ignore (translated at render site)
    name: "accommodation_costs",
    placeholder: "",
    type: "checkbox-input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    radioName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "remuneration_info",
  },
  {
    label: "ค่าพาหนะในการเดินทาง", // i18n-ignore (translated at render site)
    name: "transportation_costs",
    placeholder: "",
    type: "checkbox-input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    radioName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "remuneration_info",
  },
  {
    label: "อื่นๆ", // i18n-ignore (translated at render site)
    name: "other",
    placeholder: "",
    type: "checkbox-input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    radioName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "remuneration_info",
  },

  {
    label: "เหตุผลความจำเป็นที่ขออยู่ปฏิบัติงานต่อ", // i18n-ignore (translated at render site)
    name: "reasons_necessity_continue",
    placeholder: "",
    type: "textarea",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "reason",
  },
  {
    label: "ประโยชน์ที่ทางมหาวิทยาลัยจะได้รับ", // i18n-ignore (translated at render site)
    name: "benefit_university_receive",
    placeholder: "",
    type: "textarea",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "reason",
  },
];

export default generateForm08;
